import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQAccordion({ faqs = [] }) {
  if (!faqs.length) return null;
  return (
    <Accordion type="single" collapsible className="w-full">
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-slate-200">
          <AccordionTrigger className="text-left font-sans text-base font-semibold text-navy hover:text-gold hover:no-underline">
            {f.q || f.question}
          </AccordionTrigger>
          <AccordionContent className="text-sm leading-relaxed text-slate-600">
            {f.a || f.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
